<template>
    <div id="game" :class="['futura',layoutProfile && layoutProfile.layout == 1 ? '' : 'game row', players ? 'playercount-'+players.length : '']">
        <template v-if="screentype =='bottom'">
            <game-asset-v-3-bottom-button></game-asset-v-3-bottom-button>
            <numpad :keyboardOnly="true" :disabledInput='disabledInput || !currentPlayer' :game_id="game.id" ref="numpad"></numpad>
        </template>
        <template v-else-if="layoutProfile && layoutProfile.layout == 1">
            <div class="game2022">
                <viewer :stream_ids="JSON.stringify(webcamdata)" :auth_user_id="logged_in_user" v-if="webcamdata && webcamdata.length > 0"/>
                <game-asset-v-3-score-active-player></game-asset-v-3-score-active-player>
                <game-asset-v-3-history v-if="layoutProfile.show_history"></game-asset-v-3-history>
                <div class="game-players">
                    <game-asset-v-3-score-player v-for="player, idx in players" :playerIndex="idx" :playerId="player.player_id" :key="idx"></game-asset-v-3-score-player>
                </div>
                <numpad :keyboardOnly="true" :disabledInput='disabledInput || !currentPlayer' :game_id="game.id" ref="numpad"></numpad>
            </div>
        </template>
        <template v-else-if="layoutProfile && layoutProfile.layout == 2">
            <div class="game2022">
                <game-asset-v-3-score-active-player></game-asset-v-3-score-active-player>
                <div class="game-sidebar">
                    <div class="subnav" v-if="layoutProfile && (layoutProfile.show_history || layoutProfile.show_numpad)">
                        <a href="#" :class="['item', showmenu == 'numpad' ? 'active' : 'inactive']" @click="showSubMenu('numpad')">
                            <i class="fas fa-th"></i> {{__("games.input")}}
                            <a href="#" class="numpad-helper" @click="$refs.numpad.toggleHelper()">
                                <i class="far fa-question-circle"></i>
                            </a>
                        </a>
                        <a href="#" :class="['item', showmenu == 'history' ? 'active' : 'inactive']" @click="showSubMenu('history')">
                            <i class="fas fa-list-ol"></i> {{__('games.history')}}
                        </a>
                    </div>
                    <div class="flexrow">
                        <div class="numpad" v-if="showmenu =='numpad'">
                            <numpad :disabledInput='disabledInput || !currentPlayer' :game_id="game.id" ref="numpad"></numpad>
                        </div>
                        <div class="history" v-if="showmenu =='history'">
                            <game-asset-v-3-history v-if="layoutProfile.show_history"></game-asset-v-3-history>
                            <numpad :keyboardOnly="true" :disabledInput='disabledInput || !currentPlayer' :game_id="game.id" ref="numpad"></numpad>
                        </div>
                    </div>
                </div>
                <div class="game-players">
                    <game-asset-v-3-score-player v-for="player, idx in players" :playerIndex="idx" :playerId="player.player_id" :key="idx"></game-asset-v-3-score-player>
                </div>
            </div>
        </template>
        <template v-if="layoutProfile && layoutProfile.layout == 3">
            <div class="game2022 layout-boardcamera">
                <game-asset-v-3-history player="0"></game-asset-v-3-history>
                <viewer :stream_ids="JSON.stringify(webcamdata)" :auth_user_id="logged_in_user" v-if="webcamdata"/>
                <game-asset-v-3-history player="1"></game-asset-v-3-history>
                <div class="game-players">
                    <game-asset-v-3-score-player v-for="player, idx in players" :playerIndex="idx" :playerId="player.player_id" :key="idx"></game-asset-v-3-score-player>
                </div>
                <numpad :keyboardOnly="true" :disabledInput='disabledInput || !currentPlayer' :game_id="game.id" ref="numpad"></numpad>

            </div>
        </template>
        <game-asset-v-3-stuck-dart></game-asset-v-3-stuck-dart>
        <game-asset-end-of-leg :game_prop="game" v-if="!game.winner_id" replaceHistory="flowliga"></game-asset-end-of-leg>
        <game-asset-statistics-v-2 :game_prop="game" v-if="game.winner_id" replaceHistory="flowliga"></game-asset-statistics-v-2>
    </div>
</template>

<script>

import numpad from './gameAssets/gameAssetNumpadV2.vue';
import GameAssetScorePlayer from './gameAssets/gameAssetScorePlayer.vue';
import GameAssetGameHistory from './gameAssets/gameAssetGameHistory.vue';
import GameAssetDetermineStartPlayer from './gameAssets/gameAssetDetermineStartPlayer.vue';
import GameAssetVideoPlayer from './gameAssets/gameAssetVideoPlayer.vue';
import GameAssetStatistics from './gameAssets/gameAssetStatisticsSmall.vue';
import GameAssetGameResults from './gameAssets/gameAssetGameResults.vue';

import GameManagerV2 from './gameAssets/gameManagerV2';
import moment from 'moment';


//new
import GameAssetScoresSmall from './gameAssets/gameAssetScoresSmall.vue';
import GameManager from './gameAssets/gameManager';
import GameAssetV2ScorePlayer from './gameAssets/gameAssetV2ScorePlayer.vue';
import CpuOpponent from './CpuOpponent';
import GameAssetV3BottomButton from './v3/gameAssetV3BottomButton.vue';

export default {
    components: {
        numpad,
        GameAssetScorePlayer,
        GameAssetGameHistory,
        GameAssetDetermineStartPlayer,
        GameAssetVideoPlayer,
        GameAssetStatistics,
        GameAssetGameResults,
        GameAssetScoresSmall,
        GameAssetV2ScorePlayer,
        GameAssetV3BottomButton
    },
    props: ['game_prop', 'players_prop', 'logged_in_user', 'logged_in_player', 'webcamdata'],
    mixins: [],
    data() {
        return {
            game: this.game_prop,
            disabledInput: false,
            numpadTempScore: "",
            players: null,
            sendInputTimer: null,
            endOfLeg: false,
            endOfGame: false,
            currentPlayer: false,
            layoutProfile: null,
            showmenu: 'numpad',
            cputhrow: false,
            screentype: '',
        }
    },
    created() {
        // create game manager object and read options
        this.gm = new GameManagerV2(this.game, this);
        window.logged_in_user = this.logged_in_user;
        this.screentype = window.name;
    },
    mounted() {
        this.layoutProfile = window.currentProfile ? window.currentProfile : { layout: 1, show_history: true, show_numpad: true };
        if (!this.layoutProfile.show_numpad && this.layoutProfile.show_history) this.showmenu = 'history';

        window.connection.subscribe(this);
        this.update(window.connection.lastUpdate);
    },
    methods: {
        update(data) {
            if (data == null) return;
            //update players from gamestate
            if (this.players == null) {
                this.players = data.players;
            }

            //check if current player is the player in the browser
            this.currentPlayer = data.gameState.currentPlayer == this.logged_in_player || data.gameState.currentUser == this.logged_in_user;

            if (data.action == "endOfLeg" || data.action == "endOfGame") {
                this.disabledInput = true;
            }
            if (data.action == "newLegStart") {
                this.disabledInput = false;
            }

            //CPU Throw
            // check if next player is a cpu and if the user id matches, do a cpu throw
            if ((data.action == "nextPlayer" || data.action == "newLegStart" || data.action == null) && data.gameState.currentUserType == "computer" && data.gameState.currentUser == this.logged_in_user && !this.cputhrow) {
                this.cputhrow = true;
                this.currentPlayer = false; //disables the numpad
                var cpuplayer = data.gameState.scores[data.gameState.currentPlayerIndex];
                var cpu = new CpuOpponent(cpuplayer.player_id, cpuplayer.score, cpuplayer.cpu_level, this.game.id, cpuplayer.nextplayertime);
                setTimeout(() => {
                    cpu.throw();
                    this.cputhrow = false;
                }, cpuplayer.nextplayertime * 1000);
            }
        },
        showSubMenu(name) {
            this.showmenu = name;
        }
    }
}
</script>

<style scoped>
</style>
